<template>
  <bita-modal
    id="addressesModal"
    :title="title"
    :modal-lg="true"
    :isLoading="isLoading"
  >
    <div slot="body">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>#</th>
            <th>استان</th>
            <th>شهر</th>
            <th>منطقه</th>
            <th>شماره تماس</th>
            <th>آدرس</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in entites" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.province }}</td>
            <td>{{ item.city }}</td>
            <td>{{ item.district }}</td>
            <td>{{ item.mobile }}</td>
            <td>{{ item.address }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </bita-modal>
</template>
<script>
import { userApi } from "@/api/apiManagement.js";

export default {
  data() {
    return {
      colWidth: "col-lg-4 col-md-6 col-sm-6",
      isLoading: false,
      entites: [],
      dataForm: {},
      user: {},
    };
  },
  computed: {
    title() {
      return `آدرس های ${this.user.full_name}`;
    },
  },
  methods: {
    init(user) {
      this.user = user;
      this.isLoading = true;
      this.$showModal("#addressesModal");
      userApi
        .getUserAddresses(user.id)
        .then(({ data }) => {
          this.entites = data.entity.addresses;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    setErrors(_errors) {
      this.$refs.form.setErrors(_errors);
    },
  },
};
</script>
<style scoped>
img {
  width: 75px;
  max-height: 120px;
}
.custom-file-label {
  padding: 0.5rem 4.2rem 0 0;
}
.center-align {
  text-align: center;
}
</style>
